import {Injectable, ViewChild} from "@angular/core";
import {Observable, Subscription} from "rxjs";
import {NestApiProvider} from "../../../shared/nestjs/nest-api";
import { TrainingHistoryApiProvider } from "../../../shared/nestjs/training/training-history-api";
import { RequestCategory, RequestCourse, RequestRoom } from "../../../shared/nestjs/gd-integrated/dto/training.dto";
import moment from 'moment';
import { NestResponsesProvider } from "../../../shared/nestjs/nest-responses";
import { Platform } from "ionic-angular";
import { CameraNative } from "../../../native/camera.native";
import { FileUploaderProvider } from "../../../providers/file-uploader/file-uploader";
import { CameraOptions } from "@ionic-native/camera";
import { UploadAttachmentProvider } from "../../../providers/upload-attachment/upload-attachment";
import { StorageApi } from "../../../shared/nestjs/gd-integrated/services/storage.api";
// import { StoragePathProvider } from "../../../providers/storage-path/storage-path";
import { map } from "rxjs/operators";

@Injectable()
export class TrainingNewrequestBloc {
  subscriptions: Array<Subscription> = [];
  selectedEmployeeName : any = [];
  selectedEmployee : any = [];
  categoryList: any = [];
  currencyList: any = [];
  courseList: any = [];
  venueList: any = [];
  roomList: any = [];
  arrEmpid: any = [];
  startDate: any = moment().format();
  endDate: any = moment().format();
  trncourseCode: any = '0';
  trainingTopic: any = '';
  currency: any = 'IDR';
  language: any = 'en';
  venueCode: any = '0';
  roomCode: any = '0';
  catCode: any = '0';
  tempurl: any = '';
  reason: any = '';
  SFGoAuth: any;
  limitdate: any;
  amount: any;
  jobTitle: boolean = true;
  isValid: boolean = false;
  selectEmployee: any = [];
  allEmp: any;
  participantName: any;
  mindiff: any = new Date().getTimezoneOffset();
  popBack: any;
  
  @ViewChild('fileInputAttch') fileInputAttch;
  url: any = '';
  eventsWebview: any = '';
  options: any = '';
  isFile: boolean = false;
  fileName: string = '';
  public isDisabled: boolean = false;


  constructor(
    public nestApiProvider: NestApiProvider,
    public traininghistoryApi: TrainingHistoryApiProvider,
    public nestResponsesProvider: NestResponsesProvider,
    private platform: Platform,
    private cameraNative: CameraNative,
    private fileUploaderProvider: FileUploaderProvider,
    public uploadAttachmentProvider: UploadAttachmentProvider,
    public storageApi: StorageApi,
		// private storagePathProvider: StoragePathProvider,
  ) {
  }

  dispose() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  // async add(data,fileName): Observable<ResponseSaveDto> {
  add(data): Observable<any> {
    console.log('>>- Add', data)
    return this.traininghistoryApi.add(data);
  }

  // async save(data,fileName): Observable<any> {
  save(data): Observable<any> {
    console.log('>>- Save', data)    
    return this.traininghistoryApi.save(data);
  }

  delete(data): Observable<any> {
    console.log('>>- Del')    
    return this.traininghistoryApi.delete(data);
  }

  // updatePost(result, fileName) {
  //   let requestNo = result.data.requestNo;
  //   console.log('>>- Add', result.data.requestNo, fileName, requestNo)
  //   return this.traininghistoryApi.updatePost({requestNo, fileName});
  // }

  getCategory(payload: RequestCategory) {
    return new Promise<any>(async (resolve, reject) => {
      this.subscriptions.push(
        this.traininghistoryApi.categoryList({lang: payload.lang}).subscribe(async result => {
          let categoryList = [];
          if (result.data) {
            categoryList = result.data;
            let objCategory = {
              catCode: '0',
              catName: 'Select'
            }
            categoryList.splice(0, 0, objCategory);
          } 
          resolve(categoryList);
        }, error => {
          reject(error)
          console.log("error", error);
          }
        )
      )
    })
  }

  getCourse(payload: RequestCourse) {
    return new Promise<any>(async (resolve, reject) => {
      this.subscriptions.push(
        this.traininghistoryApi.course({lang: payload.lang, jobTitle: payload.jobTitle, catCode: payload.catCode}).subscribe(result => {
          let courseList = [];
          if (result.data) {
            courseList = result.data;
            let objCourse = {
              trncourseCode: '0',
              companyCode: '0',
              trncourseName: 'Select',
              jobtitleCode: null,
              typeCode: null,
              trncourseCost: null,
              currencyCost: null,
              catCode: '0'
            }
            courseList.splice(0, 0, objCourse);
          }
          console.log('>>- Return courseList', courseList)
          resolve(courseList);
        }, error => {
          reject(error)
          console.log("error", error);
          }
        )
      )
    }
  )}

  async getCurrency() {
    return new Promise<any>(async (resolve, reject) => {
      this.subscriptions.push(
        this.traininghistoryApi.currency().subscribe(result => {
          let currencyList = [];
          if (result.data) {
            currencyList = result.data;
          }
          resolve(currencyList);
        }, error => {
          reject(error)
          console.log("error", error);
          }
        )
      )
    })
  }

  getVenue() {
    return new Promise<any>(async (resolve, reject) => {
      this.subscriptions.push(
        this.traininghistoryApi.venue().subscribe(result => {
          let venueList = [];
          if (result.data) {
            venueList = result.data;
            let objVenue = {
              venueCode: '0',
              companyCode: '0',
              venueName: 'Select'
            }
            venueList.splice(0, 0, objVenue);
          }
          resolve(venueList);          
        }, error => {
          reject(error);          
          console.log("error", error);
          }
        )
      )
    }
  )}

  getRoom(payload: RequestRoom) {
    this.roomList = [];
    return new Promise<any>(async (resolve,reject) => {
      this.subscriptions.push(
        this.traininghistoryApi.room({venueCode: payload.venueCode}).subscribe(result => {
          let roomList = [];
          if (result.data) {
            roomList = result.data;
            let objRoom = {
              venueCode: '0',
              code: '0',
              companyCode: '0',
              name: 'Select'
            }
            roomList.splice(0, 0, objRoom);
          }
          resolve(roomList);
        }, error => {
          reject(error)
          console.log("error", error);
          }
        )
      )
    }
  )}

  async getNewRequestDetail(payload): Promise<void> {
    return new Promise<any>(async (resolve, reject) => {
      this.subscriptions.push(
        this.traininghistoryApi.historyNewRequest({lang: payload.lang, requestNo: payload.requestNo}).subscribe(async result => {
          let historyData = [];
          if (result.data) {
            try {
              console.log('>>- GetNewRequestDetail', result)
              historyData = result.data;
              historyData['catCode'] = result.data.catCode ? result.data.catCode : '0';
              historyData['trncourseCode'] = result.data.trncourseCode ? result.data.trncourseCode : '0';
              historyData['venueCode'] = result.data.venueCode ? result.data.venueCode : '0';
              historyData['roomCode'] = result.data.roomCode ? result.data.roomCode : '0';

              let categoryList = await this.getCategory({lang: payload.lang});
              let venueList = await this.getVenue();
              let currencyList = await this.getCurrency();
              let roomList = await this.getRoom({venueCode: result.data.venueCode});
              let courseList = await this.getCourse({lang: payload.lang, jobTitle: result.data.relatedjobtitle, catCode: result.data.catCode});

              historyData['categoryList'] = categoryList;
              historyData['venueList'] = venueList;
              historyData['currencyList'] = currencyList;
              historyData['roomList'] = roomList;
              historyData['courseList'] = courseList;
              console.log('>>- HistoryData result', historyData)

              resolve(historyData);
            } catch  (error) {
              console.log(error)
            }
          } 
          resolve(historyData);
        }, error => {
          reject()
          console.log("error", error);
          }
        )
      )
    })
  }

  formatDate() {
    let d = new Date(),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('');
  }

  makeid() {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    for (let i = 0; i < 12; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  makeidsf6() {
    let text = '';
    const possible = '0123456789';
    for (let i = 0; i < 3; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }
  
  // processWebImage(event, isFile) {
  //   let name = event.target.files[0].name;
  //   let fileIMG: any = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
  //   let formatImage = name.split('.').pop();
  //   let res = formatImage.toLowerCase();
  //   this.isFile = isFile;
  //   let options = isFile ? name : this.SFGoAuth.companyCode + '_IMG_' + this.formatDate() + '_' + this.SFGoAuth.userId + '_' + this.makeid().toString() + '.jpg';
  //   this.fileName = isFile ? name : '';
  //   if (fileIMG.indexOf(res) < 0 && !isFile) {
  //     this.fileName = '';
  //     this.alertService.createMola('File type is invalid').then(() => {
  //     });
  //   } else {
  //     let base: any;
  //     let reader = new FileReader();
  //     reader.addEventListener('load', () => {
  //       base = reader.result;
  //       this.url = base;
  //       this.eventsWebview = event;
  //       this.options = options;
  //       console.log("this.url", this.url);
  //       // loading.dismiss();
  //     }, false);
  //     reader.readAsDataURL(event.target.files[0]);
  //   }
  // }

  async takePicture(isCamera: boolean) {
		if (this.platform.is('cordova')) {
			const cameraOption: CameraOptions = {
				sourceType: isCamera ? this.cameraNative.camera.PictureSourceType.CAMERA : this.cameraNative.camera.PictureSourceType.PHOTOLIBRARY
			}
			const camera = await this.cameraNative.getPicture(cameraOption)
			return camera.nativeURL;
		}
  }
  
  processWebImage(event) {
		return new Promise((resolve, reject) => {
			let name = event.target.files[0].name;
			let fileIMG = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
			let formatImage = name.split('.').pop();
			let res = formatImage.toLowerCase();

			if (fileIMG.indexOf(res) < 0) {
				reject('File type is invalid.')
			} else {
				const reader = new FileReader();
				reader.addEventListener('load', () => {
					resolve(reader.result);
				}, false);
				reader.readAsDataURL(event.target.files[0]);
			}
		})
	}

  createFileName(SFGoAuth, isCamera: boolean, picture, fileType) {
    console.log('createFileName SFGoAuth', SFGoAuth)
    let result = '';
    if (isCamera == false && !picture && !fileType) {
      result = 'TRNGD' +SFGoAuth.empNo + this.formatDate() + this.makeidsf6().toString();
    }

    if (fileType) {
      result = SFGoAuth.companyCode + '_FILE_' + this.formatDate() + '_' + SFGoAuth.userId + '_' + this.makeid().toString() + '.' + fileType; 
    } else{
      result = isCamera ? 'IMG_' + this.formatDate() + '_' +  SFGoAuth.userId + '_' + picture.substr(picture.lastIndexOf('/') + 1) : 'IMG_' + this.formatDate() + '_' + SFGoAuth.userId + '_' + this.makeid().toString() + '.jpg';
    }
		return result;
  }
  
  deleteAttch(chip: Element, url) {
    this.url = '';
  }

  uploadAttachment(dataValue): Promise<any> {
    console.log('>>-uploadAttachment bloc', dataValue)
    try {
      return new Promise(async (resolve, reject) => {
        const data = {
          url: dataValue.url,
          options: dataValue.options,
          eventsWebview: dataValue.eventsWebview,
          uploadCode: 'trnrequest'
        };
      
        const objUpload = {REWRITE: "YES", RENAME: dataValue.fileName, voidonerror: "true"};
        const payload = await this.uploadAttachmentProvider.getTokenAttachment(data, objUpload);
        console.log('payload',payload)
        if (this.platform.is('cordova')) {
          console.log('>>- CORDOVA')
          const blob = await this.fileUploaderProvider.processFileFromUri(data.url);
          this.subscriptions.push(
            this.storageApi.uploadSf6(blob, payload.url, payload.configs, data.options.fileName).subscribe(
              res => {
                console.log('>>- CORDOVA RESULT', res)
                resolve(res)
                // if (res.data.SERVERFILE) {
                //   if (dataValue.isEdit) {
                //     console.log('>>- ELSECORDOVA isEdit', res)
                //     dataValue.formData['trnreq_attachment'] = res.data.SERVERFILE;
                //     console.log('>>- DATAVALUE', dataValue)
                //     let resultAdd = this.add(dataValue.formData)
                //     console.log('resultAdd', resultAdd)
                //     // resolve(resultAdd);
                //   } else {
                //     console.log('>>- ELSECORDOVA !isEdit', res)
                //     dataValue.formData['trnreq_attachment'] = res.data.SERVERFILE;
                //     console.log('>>- DATAVALUE', dataValue)
                //     let resultSave = this.save(dataValue.formData)
                //     console.log('resultSave', resultSave)
                //     // resolve(resultSave);
                //   }
                // } else {
                //   resolve({message: res.data.ERRMSG});
                // }
              },
              error => {
                console.log('>>- CORDOVA ERORR', error)
                reject(error.error.message);
              }
            )
          )
        } else {
          console.log('>>- ELSECORDOVA', dataValue.eventsWebview.target.files[0], 'payload.url', payload.url, 'payload.configs', payload.configs)
          this.subscriptions.push(
            this.storageApi.uploadSf6(dataValue.eventsWebview.target.files[0], payload.url, payload.configs).subscribe(
              res => {
                console.log('>>- ELSECORDOVA RESULT', res)
                resolve(res)
                // if (res.data.SERVERFILE) {
                //   if (dataValue.isEdit) {
                //     console.log('>>- ELSECORDOVA isEdit', res)
                //     let resultAdd = this.add(dataValue.formData)
                //     console.log('resultAdd', resultAdd)
                //     resolve(resultAdd);
                //   } else {
                //     console.log('>>- ELSECORDOVA !isEdit', res)
                //     let resultSave = this.save(dataValue.formData)
                //     console.log('resultSave', resultSave)
                //     resolve(resultSave);
                //   }
                // } else {
                //   resolve({message: res.data.ERRMSG});
                // }
              },
              error => {
                console.log('>>- ELSECORDOVA ERORR', error)
                reject(error.error.message);
              }
            )
          )
        }
      })
    } catch (error) {
      console.log('error uploading', error)
    }
  }

  // Get Calendar
	getCalendarTraining(data: any): Observable<any> {
		return this.traininghistoryApi.list(data).pipe(
			map(params => {
				const colorNote = [];
				for (const item of params.data) {
					colorNote.push({
						date: item,
						event: [
							{
								color: '#008000',
							}
						]
					});
				}
				return colorNote;
			})
		)
	}

  // Get Detail Calendar
	getCalendarTrainingDetail(data: any): Observable<any> {
		return this.traininghistoryApi.listDetail(data).pipe(
			map(params => {
				return params.data;
			})
		)
	}

  async formatCalendarTrainingDetail(data: any): Promise<any> {
		const dataTraining = [];
		console.log('formatCalendarTrainingDetail', data)
    for (const item of data) {
      let availableWaiting = (item.trnevent_sts != 2) ? false : (item.count_participant_member < item.trnevent_capacity && item.is_user_exist > 0) ? true : false;
      dataTraining.push({
        capacity: item.count_participant_member ? item.count_participant_member : '0' + '/' + item.trnevent_capacity,
        availableWaitingColor: '#FC0000',
        waiting: availableWaiting,
        trneventCode: item.trnevent_code,
        trncourseCode: item.trncourse_code,
        name: item.trnevent_topic,
      });
    }
		return {
      date: data,
			event: (dataTraining.length > 0) ? [
				{
					group: 'Existing Training Request',
					color: '#F0624D',
					data: dataTraining
				}
			] : []
		}
	}
}



// WEBPACK FOOTER //
// ./src/bloc/hr/training/training-newrequest.bloc.ts